import { makeStyles } from '@material-ui/core/styles'

import buttonStyle from 'assets/jss/material-dashboard-pro-react/components/buttonStyle'
import switchStyles from 'assets/jss/material-dashboard-pro-react/customCheckboxRadioSwitch'

export default makeStyles((theme) => ({
  ...switchStyles,
  root: {
    flexGrow: 1,
    backgroundColor: '#FAFAFA',
  },
  wrapper: {
    margin: theme.spacing(1),
    position: 'relative',
  },
  btnBackgroundPrimary: {
    marginBottom: 4,
    fontSize: 14,
    height: '56px',
    borderRadius: '50px',
    border: 'none',
    backgroundColor: '#5e44ff',
    color: 'white',
    fontWeight: '500',
    '&:hover': {
      fontWeight: 'bolder',
      backgroundColor: '#ef0bef',
      boxShadow: '-7px 7px 0px #000000',
      border: '2px solid #000000',
      borderRadius: '50px',
      opacity: '1',
    },
  },
  btnBackgroundDeclaration: {
    width: '248px',
    height: '56px',
    borderRadius: '50px',
    border: 'none',
    margin: '20px auto',
    backgroundColor: '#5e44ff',
    color: 'white',
    fontWeight: '500',
    '&:hover': {
      fontWeight: 'bolder',
      backgroundColor: '#ef0bef',
      boxShadow: '-7px 7px 0px #000000',
      border: '2px solid #000000',
      borderRadius: '50px',
      opacity: '1',
    },
  },
  btnSecondary: {
    height: 52,
    fontSize: 14,
    '&:hover': {
      color: '#5E44FF',
      backgroundColor: '#00000000',
    },
  },
  btnBackgroundError: {
    height: 52,
    fontSize: 14,
    '&:hover': {
      color: theme.palette.error.main,
      backgroundColor: '#00000000',
    },
  },
  formControl: {
    margin: theme.spacing(1),
    width: '200px ',
  },
  logo: {
    marginLeft: '50%',
    transform: 'transLate(-50%)',
    width: 480,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  inputBorder: {
    borderColor: '#FF0000 !important',
    borderWidth: '1px !important',
  },
  button: {
    margin: theme.spacing(1),
  },
  buttonAction: {
    marginLeft: 10,
  },
  ...buttonStyle,
  chip: {
    marginLeft: 30,
  },
  card: {
    minHeight: 100,
    padding: 20,
  },
  alert: { position: 'fixed', zIndex: 1, marginBottom: 20 },
  gridList: {
    flexWrap: 'nowrap',
    width: '100%',
    // Promote the list into his own layer on Chrome. This cost memory but helps keeping high FPS.
    transform: 'translateZ(0)',
  },
  gridListIndividual: {
    width: '100%',
    // height: 450,
  },
  iconDelete: {
    color: 'rgba(244, 67, 54)',
  },

  iconAdd: {
    marginTop: '10%',
  },
  rootList: {
    width: '850px',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
    // overflow: 'hidden',
    backgroundColor: theme.palette.background.paper,
  },
  rootListIndividual: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    overflow: 'hidden',
    backgroundColor: theme.palette.background.paper,
  },
  input: {
    display: 'none',
  },
  imageProduct: {
    width: '150px',
    marginLeft: '25%',
  },
  cardList: {
    flexWrap: 'nowrap',
    // Promote the list into his own layer on Chrome. This cost memory but helps keeping high FPS.
    transform: 'translateZ(0)',
  },
  imageTitle: {
    color: 'white',
  },
  inputTop: {
    marginTop: '20px',
  },
  tableContainer: {
    width: 'auto',
  },
  center: {
    margin: `${theme.spacing(1)}px auto`,
  },
  margin: {
    margin: theme.spacing(1),
  },
  topInputLabel: {
    margin: '0 0 7px 0',
    fontSize: 14,
  },
  divTitle: {
    borderBottom: '1px solid #949494',
    paddingBottom: '1px',
    marginBottom: '30px',
    webkitBoxShadow: '0px 2px 5px 1px rgba(0,0,0,0.36)',
    mozBoxShadow: '0px 2px 5px 1px rgba(0,0,0,0.36)',
    boxShadow: '0px 2px 5px -2px rgba(0,0,0,0.36)',
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
  buttonMargin: {
    marginRight: 8,
  },
  buttonSave: {
    marginTop: 12,
    marginRight: 69,
  },
  typeletra: {
    fontSize: 20,
  },
  gridQuestionsMarketing: {
    gridGap: '1px',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gridTemplateRows: 'repeat(4, auto)',
  },
  paddincheck: {
    marginLeft: 19,
  },
  divTermsAndConditions: {
    marginBottom: '2%',
  },
  labelInputTop: {
    margin: '7px 0',
  },
  labelInputAnyTop: {
    marginBottom: '7px',
  },
  marginInfo: {
    marginLeft: '8px',
  },
  infoBussiness: {
    marginLeft: '15px',
  },
  infoIdentification: {
    marginLeft: '18px',
    marginTop: '4%',
    width: '45%',
  },
  gridSpacing: {
    width: '90%',
    marginLeft: 10,
  },
  hoverPurple: {
    '&:hover': {
      borderColor: '#5E44FF',
      color: '#5E44FF',
    },
  },
  typePerson: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: 150,
    '&:hover': {
      cursor: 'pointer',
      borderColor: '#5E44FF',
      color: '#5E44FF',
      boxShadow: '0px 0px 2px 1px #5E44FF',
    },
  },

  rootStepIcon: {
    fontSize: 40,
  },

  header: {
    height: '50%',
    background: '#5E44FF',
    padding: '10px 0 10px 0',
  },
  termsAndConditions: {
    marginBottom: '1%',
    color: '#FFFFFF',
    fontSize: '10px',
  },
  bienvenidoSeller: {
    color: '#FFFFFF',
    marginBottom: '2px',
    fontSize: '22px',
  },
  Logo: {
    maxWidth: '380px',
  },
  main: {
    backgroundColor: '#FAFAFA',
    display: 'flex',
    minHeight: '100vh',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'stretch',
  },
  termsAndConditionsFooter: {
    color: theme.palette.black.main,
    marginBottom: '1%',
    fontSize: '10px',
  },
  wrapInput: {
    marginTop: '5%',
    minWidth: 286,
    maxWidth: 319,
  },
  wrapInputPersonType: {
    width: 280,
    marginBottom: 292,
  },
  gridInfoAndForm: {
    columnGap: '30px',
    marginTop: '5%',
  },
  autocompleteMargin: {
    marginTop: '-17px',
  },
  errorCertificate: {
    boxShadow: '0px 0px 2px 1px red',
  },
  form: {
    padding: '24px 20%',
    [theme.breakpoints.down('lg')]: {
      padding: '24px 15%',
    },
    [theme.breakpoints.down('md')]: {
      padding: '24px 10%',
    },
    [theme.breakpoints.down('sm')]: {
      padding: '24px 5%',
    },
  },
  btnAceptar: {
    backgroundColor: '#5E44FF',
    minWidth: 286,
    maxWidth: 319,
    height: 44,
    color: 'white',
    '&:hover': {
      backgroundColor: '#EF16EF',
      boxShadow: 'none',
    },
    [theme.breakpoints.down('sm')]: {
      minWidth: '100%',
      marginBottom: '10%',
    },
  },
  formDeclaration: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  formPop: {
    cursor: 'pointer',
    textDecoration: 'underline',
  },
  active: {
    color: `${theme.palette.secondary.blue} !important`,
    border: 'none',
    '& $text': {
      fill: '#ffffff !important',
    },
  },
  completed: {
    color: `${theme.palette.primary.green} !important`,
    border: 'none',
  },

  labelStepLabel: {
    color: '#1c2d52',
    fontWeight: 'bold !important',
    fontFamily: 'Red Hat Display Medium !important',
    fontSize: '16px',
  },
  activeStepLabel: {
    color: `${theme.palette.secondary.blue} !important`,
    fontWeight: 'bold !important',
    fontFamily: 'Red Hat Display Medium !important',
    fontSize: '16px',
  },
  completedStepLabel: {
    color: `${theme.palette.primary.green} !important`,
    fontWeight: 'bold !important',
    fontFamily: 'Red Hat Display Medium !important',
    fontSize: '16px',
  },
  positionElements: {
    '& .MuiSwitch-colorPrimary.Mui-checked + .MuiSwitch-track': {
      backgroundColor: theme.palette.secondary.blue,
    },
    '& .MuiSwitch-sizeSmall .MuiSwitch-thumb': {
      color: theme.palette.secondary.blue,
    },
  },
  editEmail: {
    display: 'flex',
  },
  identificationFieldWrapper: {
    position: 'relative',
  },
  nitHelperText: {
    position: 'absolute',
    bottom: '-14px',
    left: '14px',
    color: 'rgba(0, 0, 0, 0.54)',
    pointerEvents: 'none',
  },
}))
